import { useMemo, useState } from 'react';
import LastWakeContext from './LastWakeContext';

export default function LastWakeProvider({ children }) {
  const [lastWake, setLastWake] = useState(null);

  // Function to update lastWake
  const updateLastWake = () => {
    setLastWake(Date.now());
  };

  const wakeMemo = useMemo(() => ({ lastWake, updateLastWake }), [lastWake]);

  return (
    <LastWakeContext.Provider value={wakeMemo}>
      {children}
    </LastWakeContext.Provider>
  );
}
